<!-- Zero State -->
<div *ngIf="allowManage &&
  selectedLocations.length === 0">
  <div class="font-875-rem font-550 mb-3">
    <yc-i18n
      key="common:textAllLocationsSupported"
      defaultValue="All locations supported">
    </yc-i18n>
  </div>
  <yc-button
    [link]="true"
    [langKey]="'common:textManageLocations'"
    [defaultText]="'Manage locations'"
    (onClick)="manageLocations()">
  </yc-button>
</div>


<div *ngIf="selectedLocations.length > 0">
  <div *ngFor="let location of selectedLocations; let index = index;"
    class="d-flex align-items-center">
    <!-- Country Select -->
    <yc-typeahead-select
      class="flex-basis-47 me-2"
      [name]="'country_' + index"
      [showClear]="true"
      [disabled]="!allowManage"
      [placeholder]="'common:textSelectACountry' | ycI18n: 'Select a country'"
      [(value)]="location.countryId"
      [items]="countryOptionsMap[index]"
      (valueChange)="handleCountryChange(index)">
    </yc-typeahead-select>

    <!-- Regions Select -->
    <yc-typeahead-select *ngIf="!!location.countryId"
      class="flex-basis-47 me-2"
      [name]="'regions_' + (index)"
      [(value)]="location.regionIds"
      [multi]="true"
      [disabled]="!allowManage"
      [items]="countryIdToRegionOptionsMap[location.countryId]"
      (onItemAdded)="regionAdded($event, index)"
      (onItemRemoved)="regionRemoved($event, index)">
    </yc-typeahead-select>

    <!-- Delete -->
    <yc-button *ngIf="allowManage"
      class="flex-basis-5"
      [icon]="true"
      [fontAwesomeIcon]="'times'"
      [textDanger]="true"
      [tooltipText]="'common:textRemove' | ycI18n: 'Remove'"
      (onClick)="removeCountry(index)">
    </yc-button>
  </div>
  <!-- Add Another -->
  <div *ngIf="allowManage">
    <yc-button *ngIf="!hasEmptyCountrySelect"
      [link]="true"
      [fontAwesomeIcon]="'plus'"
      [langKey]="'common:btnSelectAnother'"
      [defaultText]="'Select another'"
      (onClick)="addCountry()">
    </yc-button>
  </div>
</div>